import { Controller } from "@hotwired/stimulus"

// Folds the projections ledger's quarters into totals and back, remembering each
// viewer's choice per year, and switches which month's forecast breakdown shows.
export default class extends Controller {
  static targets = ["breakdown", "breakdownToggle", "allToggle"]
  static values = { year: Number, expanded: Array }

  connect() {
    this.expanded = this.storedExpanded() ?? this.expandedValue
    this.render()
  }

  toggleQuarter({ params: { quarter } }) {
    this.expanded = this.expanded.includes(quarter)
      ? this.expanded.filter((number) => number !== quarter)
      : [...this.expanded, quarter]
    this.store()
    this.render()
  }

  toggleAll() {
    this.expanded = this.allExpanded ? this.expandedValue : [1, 2, 3, 4]
    this.store()
    this.render()
  }

  showBreakdown({ params: { slot } }) {
    const selected = String(slot)
    this.breakdownTargets.forEach((panel) => { panel.hidden = panel.dataset.slot !== selected })
    this.breakdownToggleTargets.forEach((button) => {
      button.setAttribute("aria-pressed", String(button.dataset.slot === selected))
    })
  }

  render() {
    this.element.querySelectorAll("[data-quarter]").forEach((cell) => {
      const expanded = this.expanded.includes(Number(cell.dataset.quarter))
      cell.hidden = (cell.dataset.ledgerView === "months") !== expanded
    })
    if (this.hasAllToggleTarget) {
      this.allToggleTarget.textContent = this.allExpanded ? "Current quarter only" : "Show all months"
      this.allToggleTarget.setAttribute("aria-expanded", String(this.allExpanded))
    }
  }

  get allExpanded() {
    return this.expanded.length === 4
  }

  get storageKey() {
    return `ledger-quarters-${this.yearValue}`
  }

  storedExpanded() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.storageKey))
      return Array.isArray(stored) ? stored : null
    } catch {
      return null
    }
  }

  store() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.expanded))
    } catch {
      // Private mode or blocked storage: the layout still works, it just isn't remembered.
    }
  }
}
